import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import ClickableItem from './ClickableItem';
import ClickableItemWithSelect from './ClickableItemWithSelect';

import './selectOptions.scss';

const selectOptions = props => {
  const { title, items, withBorder, colSize, id, selected, callback } = props;

  let className = 'Select-Options';

  if (withBorder) className += ' with-border';

  const range = (from, to) => [...Array(to - (from - 1)).keys()].map(i => i + from);

  return (
    <div className={className} id={id}>
      <h6>
        <label htmlFor={id} className='mb-0'>
          {title}
        </label>
      </h6>
      <Row id={id}>
        {items.map((item, index) =>
          <Col
            md={colSize}
            sm={colSize}
            xs={colSize}
            className="selector-column mt-2"
            key={index}
          >
            {item.hasOwnProperty('min_quantity') && item.min_quantity !== item.max_quantity ?
            <ClickableItemWithSelect
              title={item.name}
              id={item.id}
              description={item.description}
              additionalText={item.additional_text || ''}
              value={item.price}
              isActive={selected.some(selectedItem => item.id === selectedItem.id )}
              callback={callback}
              options={range(item.min_quantity, item.max_quantity)}
            />
            :
            <ClickableItem
              title={item.name}
              id={item.id}
              description={(item.description || `${item.price}€ al mese`) + ` ${item.additional_text || ''}`}
              additionalText={item.additional_text || ''}
              value={item.price}
              isActive={selected.some(selectedItem => item.id === selectedItem.id )}
              callback={callback}
            />
          }
          </Col>
          )}
      </Row>
    </div>
  );
};

selectOptions.defaultProps = {
  id: '',
  withBorder: true,
  colSize: 6,
  callback: () => {},
};

selectOptions.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      price: PropTypes.any,
      callback: PropTypes.func,
    }),
  ).isRequired,
  selected: PropTypes.any.isRequired,
  withBorder: PropTypes.bool,
  colSize: PropTypes.number,
  callback: PropTypes.func,
};

export default selectOptions;
